// extracted by css-extract-rspack-plugin
export default {"confirm":"Presenter__confirm--tighT"};